exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".me[data-v-b6d31c1c] {\n  background-color: red;\n  width: 100vw;\n  height: 93.33333vw;\n}\n.m2[data-v-b6d31c1c] {\n  padding-top: 1vw;\n  background-color: yellow;\n  width: 100vw;\n  height: 93.33333vw;\n}\n", ""]);
